import PropTypes from 'prop-types';
import React, { createRef, useEffect, useState, forwardRef } from 'react';

import { getAwardsBgColor } from '$utilities/data';
import { useAnchor } from '$contexts/anchor';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const AwardsModuleLandingSlideNavigationTop = forwardRef(({ anchors }, ref) => {

    // references
    const { current } = useAnchor();
    // state
    const [ currentHighlightColor, setCurrentHighlightColor ] = useState('');
    const [ currentTitle, setCurrentTitle ] = useState('');
    const [ elRefs, setElRefs ] = useState([]);

    // hooks
    useEffect(() => {
        const foundAnchor = (anchors.find(anchor => anchor?.article?.slug === current));

        setCurrentHighlightColor(getAwardsBgColor(foundAnchor?.article?.highlightColor));
        setCurrentTitle(foundAnchor ? foundAnchor.article.title : '');
    }, [ anchors, current ]);

    useEffect(() => {
        if (anchors) {
            setElRefs((elRefs) =>
                Array(anchors.length)
                    .fill()
                    .map((_, i) => elRefs[i] || createRef()),
            );
        }
    }, [ anchors.length ]);

    // misc
    const highlightColours = [];

    anchors.map((anchor) => {
        highlightColours.push(getAwardsBgColor(anchor?.article?.highlightColor));
    });

    // render

    return (
        <nav
            className='bg-black flex items-center sticky top-0 z-10'
            ref={ref}>
            <div className='layout-container w-full'>
                <div className='px-10 sm:px-20 py-18 sm:py-0'>
                    <ul className='flex flex-row items-center'>
                        {anchors.map((anchor, idx) => {
                            return (
                                <li
                                    key={`anchor-nav-${idx}`}
                                    ref={elRefs[idx]}>
                                    <a href={`#${anchor.article.slug}`}>
                                        {anchor?.article?.slug === current ?
                                            (
                                                <div className={`flex flex-row gap-20 items-center relative sm:py-25${idx === 0 ? ' pr-40' : idx === (anchors.length - 1) ? ' pl-40' : ' px-40'}`}>
                                                    <div
                                                        className='h-[12px] w-[12px]'
                                                        style={{ backgroundColor: highlightColours[idx] }} />

                                                    <p
                                                        className='hidden sm:block type-style-awards-tiny-uppercase max-w-[175px] truncate'
                                                        style={{ color: highlightColours[idx] }}>
                                                        {anchor?.article?.title}
                                                    </p>
                                                </div>
                                            ) : (
                                                <div className={`sm:py-25${idx === 0 ? ' pr-40' : idx === (anchors.length - 1) ? ' pl-40' : ' px-40'}`}>
                                                    <div className='h-[6px] w-[6px] hover:h-[12px] hover:w-[12px] bg-white' />
                                                </div>
                                            )
                                        }
                                    </a>
                                </li>
                            );
                        })}
                    </ul>

                    <p
                        className='block sm:hidden type-style-awards-tiny-uppercase mt-18'
                        style={{ color: currentHighlightColor ? currentHighlightColor : null }}>
                        {currentTitle}
                    </p>
                </div>
            </div>
        </nav>
    );
});


/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

AwardsModuleLandingSlideNavigationTop.displayName = 'AwardsModuleLandingSlideNavigationTop';

AwardsModuleLandingSlideNavigationTop.propTypes = {
    anchors: PropTypes.array
};

export default AwardsModuleLandingSlideNavigationTop;
